import { render, staticRenderFns } from "./c-popup.vue?vue&type=template&id=3fffe874&"
import script from "./c-popup.vue?vue&type=script&lang=js&"
export * from "./c-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports